import * as React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const Loading = () => {
  return (
    <Container fluid={true}>
      <Row>
        <Col sm="12">
          <div className="loading">Načítavam, čakajte prosím ...</div>
        </Col>
      </Row>
    </Container>
  );
};

export default Loading;
